
const initialState = {
    isFetching: false,
    errorMessage: null,
    splash: true
}

export default initialState;